import { connect } from "react-redux";
import selectors from "ui/molecule/errorPage/selectors";
import NotActivatedPageUI from "ui/molecule/notActivatedPage/NotActivatedPageUI";

export default connect(selectors)(NotActivatedPageUI);
